





























import { Component } from 'vue-property-decorator';
import { UsersModule } from '@/store/Settings/UsersModule';
import { RolesModule } from '@/store/Settings/RolesModule';
import Alert from '@/components/Shared/Alert.vue';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import UserDetails from '@/components/Settings/Users/UserDetails.vue';

@Component({ name: 'User', components: { Alert, UserDetails }, metaInfo: { title: 'Users' } })
export default class extends SaascadaVue {

    tabIndex = 0;

    async created() {
        // Check for tab index number in URL parameters
        const tab = this.$route.query.tab;
        if (tab) {
            this.tabIndex = +tab;
        }
        else {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `0` } });
        }
    }

    async beforeMount() {
        await UsersModule.getUser(this.$route.params.id);
        await UsersModule.getRolesForUser(this.$route.params.id);
        await RolesModule.getRoles();
    }

    get user() {
        return UsersModule.user;
    }

    get loading() {
        return UsersModule.loading;
    }

    async changeTab() {
        // Update route with tab number
        this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.tabIndex}` } });
    }

}
